import React from "react";
import { Link } from "react-router-dom";
import BlogCards from "./BlogCards";
import { getLatestBlogPosts } from "../utils/blogRecommendations";
import "../styles/Blog.css";

function HomeBlogSection() {
  const latestPosts = getLatestBlogPosts(3);

  return (
    <section className="home-blog-section">
      <div className="container">
        <div className="home-blog-heading">
          <span>Lecturas recomendadas</span>
          <h2>Ultimos articulos del blog</h2>
          <p>
            Guias practicas sobre cursos profesionales, certificaciones y
            oportunidades reales en salud y bienestar.
          </p>
          <Link to="/blog">Ver todos los articulos</Link>
        </div>
        <BlogCards posts={latestPosts} className="blog-card-grid-three" />
      </div>
    </section>
  );
}

export default HomeBlogSection;
